import { z } from 'zod';
import { makeZodValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { externalIdentityVerificationSchema } from '../components/ExternalIdentityVerification/validation';
import { walletSteeringItemsSchema } from '../components/WalletSteering/validation';
import { fulfillmentSchema } from '../components/Fulfillment/validation';
import { ageWithinSchema } from '../components/AgeWithin/validation';
import { qualifiedEventsSchema } from '../components/QualifiedEvents/validation';
import { surveysSchema } from '../components/Surveys/validation';
import { combinedAudiencesSchema } from '../components/CombinedAudiences/validation';
import { purchasesSchema } from '../components/Purchases/validation';
import {
  makeCommunicationPreferencesSchema,
  employeeTargetingSchema,
  fuelAndConvenienceProfileSchema,
} from '../components/FuelAndConvenienceProfile/validation';
import { segmentsSchema } from '../components/Segments/validation';
import { homeStoreSchema } from '../components/HomeStore/validation';
import {
  membershipCreatedSchema,
  pointBalanceSchema,
  productInterestsSchema,
} from '../components/validation';
import { lastVisitSchema } from '../components/LastVisit/validation';

export const makeAudienceSchema = (areSubBrandsEnabled: boolean) =>
  z.object({
    name: z.string({ message: IS_REQUIRED }).min(1, IS_REQUIRED),
    description: z.string({ message: IS_REQUIRED }).min(1, IS_REQUIRED),
    ageWithin: ageWithinSchema,
    purchases: purchasesSchema,
    fulfillments: fulfillmentSchema,
    walletSteeringItems: walletSteeringItemsSchema,
    qualifiedEvents: qualifiedEventsSchema,
    lastVisit: lastVisitSchema,
    pointBalance: pointBalanceSchema,
    membershipCreated: membershipCreatedSchema,
    employeeTargetingAttributes: employeeTargetingSchema,
    surveys: surveysSchema,
    combinedAudiences: combinedAudiencesSchema,
    behaviors: fuelAndConvenienceProfileSchema,
    communicationPreferences: makeCommunicationPreferencesSchema(areSubBrandsEnabled),
    segments: segmentsSchema,
    homeStore: homeStoreSchema,
    productInterests: productInterestsSchema,
    externalIdentityVerification: externalIdentityVerificationSchema,
  });

export const audienceSchema = makeAudienceSchema(false);

export const getAudienceValidation = (areSubBrandsEnabled: boolean) =>
  makeZodValidate(makeAudienceSchema(areSubBrandsEnabled));
